import { faCheck, faClose, faExclamation, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import ptBR from "date-fns/locale/pt-BR";
import { format, parse } from "date-fns";
import { PopupTexto } from "../../components/PopupTexto/PopupTexto";

const StatusParecerAnalise = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Não avaliado" placement="right">
                    <div className="status_texto">
                        <div className="status_digitacao">
                            <FontAwesomeIcon icon={faRefresh} />
                        </div>
                        Não avaliado
                    </div>
                </Tooltip>
            );

        case 1:
            return (
                <Tooltip title="Favorável" placement="right">
                    <div className="status_texto">
                        <div className="status_homologado">
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        Favorável
                    </div>
                </Tooltip>
            );

        case 2:
            return (
                <Tooltip title="Favorável com ressalvas" placement="right">
                    <div className="status_texto">
                        <div className="status_aguardando">
                            <FontAwesomeIcon icon={faExclamation} />
                        </div>
                        Favorável com ressalvas
                    </div>
                </Tooltip>
            );

        case 3:
            return (
                <Tooltip title="Reprovado" placement="right">
                    <div className="status_texto">
                        <div className="status_cancelado">
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                        Reprovado
                    </div>
                </Tooltip>
            );
    }
};

const TipoAnalise = ({ value }) => {
    switch (value) {
        case 1:
            return "Documentação";

        case 2:
            return "Projeto";
    }
};

const formatarData = (data) => {
    if (!data) return "-";

    let dataFormatada = parse(data, "dd/MM/yyyy HH:mm:ss", new Date());

    return format(dataFormatada, "dd/MM/yyyy", {
        locale: ptBR,
    });
};

const columnsAnaliseAnaliseProjeto = [
    {
        field: "CodigoVisual",
        headerName: "Código",
        width: 120,
    },
    {
        field: "Protocolo",
        headerName: "Protocolo",
        width: 120,
    },
    {
        field: "Parecer",
        headerName: "Parecer",
        flex: 1,
        renderCell: (params) => {
            return <StatusParecerAnalise value={params.value} />;
        },
    },
    {
        field: "DataAnalise",
        headerName: "Data da análise",
        width: 180,
        renderCell: (params) => {
            return formatarData(params.value);
        },
    },
    {
        field: "Usuario",
        headerName: "Usuário",
        flex: 1,
    },
    {
        field: "MotivoReprovacao",
        headerName: "Motivo da reprovação",
        flex: 1.5,
        renderCell: (params) => {
            return <PopupTexto texto={params.value} titulo="Motivo reprovação" />;
        },
    },
    {
        field: "Ressalva",
        headerName: "Ressalva",
        flex: 1.5,
        renderCell: (params) => {
            return <PopupTexto texto={params.value} titulo="Ressalva" />;
        },
    },
];

export { columnsAnaliseAnaliseProjeto };